import { useContext } from "react";
import { AppContext } from "../../state/AppContextProvider";

export const WhenUserLoaded = (props: any) => {
  const { state } = useContext(AppContext);

  return state.isAuthLoaded && state.isConnected && state.user ? props.children : false;
};
